import { render, staticRenderFns } from "./MinTable.vue?vue&type=template&id=01af98e0&scoped=true&"
import script from "./MinTable.vue?vue&type=script&lang=js&"
export * from "./MinTable.vue?vue&type=script&lang=js&"
import style0 from "./MinTable.vue?vue&type=style&index=0&id=01af98e0&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01af98e0",
  null
  
)

export default component.exports